import TabsElement from './tabs-element.class';
customElements.define('tabs-element', TabsElement);
